import React, { useContext, useState, useEffect, useRef } from "react";
import OtpInput from "react-otp-input";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify";
import { loginUser, RegisterUser, verifyLoginOtp } from "../Libs/api";
import { MyContext } from "../hooks/MyContextProvider";
const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "white",
};
function Authentication({ isOpen, onClose }) {
  const { updateToken, updateUser } = useContext(MyContext);

  const [loading, setloading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [isPhoneError, setIsPhoneError] = useState(false);
  const [otp, setOtp] = useState("");
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [slideDirection, setSlideDirection] = useState("right");
  const [isAnimating, setIsAnimating] = useState(false);
  const [step, setStep] = useState("phone"); // "phone" | "otp"
  const [resendTimer, setResendTimer] = useState(30);
  const intervalRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Auto-slide for mobile only
  useEffect(() => {
    if (!isMobile) return;
    const startAutoSlide = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      intervalRef.current = setInterval(() => {
        if (!isPaused && !isAnimating) {
          const nextSlide = (currentSlide + 1) % features.length;
          setSlideDirection("right");
          setIsAnimating(true);
          setTimeout(() => {
            setCurrentSlide(nextSlide);
            setIsAnimating(false);
          }, 400);
        }
      }, 3000);
    };
    startAutoSlide();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isMobile, isPaused, isAnimating, currentSlide]);

  // Handle resend timer when on OTP step
  useEffect(() => {
    if (step !== "otp") return;
    setResendTimer(30);
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setResendTimer((t) => {
        if (t <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return t - 1;
      });
    }, 1000);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [step]);

  const handleDotClick = (index) => {
    if (isAnimating) return;
    const direction = index > currentSlide ? "right" : "left";
    setSlideDirection(direction);
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentSlide(index);
      setIsAnimating(false);
    }, 400);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(() => {
      if (!isPaused && !isAnimating) {
        const nextSlide = (currentSlide + 1) % features.length;
        setSlideDirection("right");
        setIsAnimating(true);
        setTimeout(() => {
          setCurrentSlide(nextSlide);
          setIsAnimating(false);
        }, 400);
      }
    }, 3000);
  };

  const handleCardHover = () => {
    if (isMobile) setIsPaused(true);
  };
  const handleCardLeave = () => {
    if (isMobile) setIsPaused(false);
  };

  const features = [
    {
      title: "Powered by Demifine",
      description: "Built to Last, Swim, Sweat, No Tarnish, no worries",
      icon: "https://assets.gokwik.co/uploads/1739885478191_Group 24408.png",
    },
    {
      title: "Exclusive Perks Just for You",
      description: "Earn Palmonas Coins. Unlock Early Bird Offers",
      icon: "https://assets.gokwik.co/uploads/1739885478191_Group 24408.png",
    },
    {
      title: "VIP Treatment, Every Time",
      description: "Exclusive Access to Palmonas' Private Events & Launches",
      icon: "https://assets.gokwik.co/uploads/1739885478191_Group 24408.png",
    },
  ];

  const onEditPhone = () => {
    setStep("phone");
    setOtp("");
  };

  const onResend = async () => {
    if (resendTimer === 0) {
      try {
        let formData = new FormData();
        formData.append("Data", phoneNumber);
        await loginUser(formData);
      } catch (error) {
        console.log(error);
      }
      setResendTimer(30);
      if (timerRef.current) clearInterval(timerRef.current);
      timerRef.current = setInterval(() => {
        setResendTimer((t) => {
          if (t <= 1) {
            clearInterval(timerRef.current);
            return 0;
          }
          return t - 1;
        });
      }, 1000);
    }
  };

  const isVerifyEnabled = otp.length === 4;

  if (!isOpen) return null;

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!phoneNumber) {
      toast.error("Please enter a  phone number");
    } else if (phoneNumber.length !== 10) {
      toast.error("Please enter a valid phone number");
    } else {
      try {
        setloading(true);
        let formData = new FormData();
        formData.append("Data", phoneNumber);
        const apiCall = await loginUser(formData);
        if (apiCall.status === "1" || apiCall.status === "2") {
          setStep("otp");
          toast.success("OTP sent successfully");
        } else {
          toast.error(apiCall?.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(error?.message || "Something went wrong");
      } finally {
        setloading(false);
      }
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    if (!otp) {
      toast.error("Please enter a otp");
    } else if (otp.length !== 4) {
      toast.error("Please enter a valid otp");
    } else {
      try {
        setloading(true);
        let formData = new FormData();
        formData.append("Data", phoneNumber);
        formData.append("OTP", otp);
        const apiCall = await verifyLoginOtp(formData);
        if (apiCall.status === "1") {
          try {
            let formData = new FormData();
            formData.append("Data", phoneNumber);
            const apiCall = await RegisterUser(formData);
            if (apiCall.status === "1") {
              updateToken(apiCall.Token);
              toast.success("Login Successfully");
              onClose();
              // setIsActive(true);
            } else {
              toast.error(apiCall?.message);
            }
          } catch (error) {
            console.log(error);
            toast.error(error?.message || "Something went wrong");
          }
          // setIsActive(true);
        } else {
          toast.error(apiCall?.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(error?.message || "Something went wrong");
      } finally {
        setloading(false);
      }
    }
  };

  const handleBack = () => {
    setIsActive(false);
    setOtp("");
  };

  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <div className="login-modal-container">
      <div className="modal-background" onClick={handleClose}></div>
      <div className="login-modal-wrapper" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-button" onClick={handleClose}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="#0d443e">
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="#0d443e"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="modal-form-section">
          {step === "phone" && (
            <>
              <div className="form-header" style={{ paddingBottom: 12 }}>
                <h2 style={{ paddingBottom: 8 }}>Explore Trisa</h2>
                <p>Luxury You Can Live In, Every Single Day.</p>
              </div>
              <div className="form-content">
                <form onSubmit={handleVerify}>
                  <div
                    className={`phone-input-group ${
                      isPhoneError ? "error" : isPhoneValid ? "success" : ""
                    }`}
                  >
                    <div className="country-code">
                      <span className="flag">🇮🇳</span>
                      <span className="code">+91</span>
                    </div>
                    <input
                      type="tel"
                      placeholder="Enter Mobile Number"
                      className="phone-input"
                      value={phoneNumber}
                      onChange={(e) => {
                        const digitsOnly = e.target.value
                          .replace(/[^0-9]/g, "")
                          .slice(0, 10);
                        setPhoneNumber(digitsOnly);
                        const valid = digitsOnly.length === 10;
                        setIsPhoneValid(valid);
                        setIsPhoneError(!valid && digitsOnly.length > 0);
                      }}
                      onBlur={() => {
                        const valid = phoneNumber.length === 10;
                        setIsPhoneValid(valid);
                        setIsPhoneError(!valid && phoneNumber.length > 0);
                      }}
                    />
                  </div>

                  <button
                    className="submit-button mt-3"
                    type="submit"
                    disabled={phoneNumber.length !== 10 || loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </form>
                <div className="form-footer">
                  <p>
                    I accept that I have read & understood your{" "}
                    <button
                      onClick={() => {
                        window.open("/privacy-policy", "_blank");
                      }}
                      className="link-button"
                    >
                      Privacy Policy
                    </button>{" "}
                    <button
                      onClick={() => {
                        window.open("/terms-and-conditions", "_blank");
                      }}
                      className="link-button"
                    >
                      and T&Cs.
                    </button>
                  </p>
                </div>
              </div>
            </>
          )}

          {step === "otp" && (
            <div className="otp-form">
              <h3 className="otp-title">OTP Verification</h3>
              <p className="otp-subtitle">Verification code sent to</p>
              <div className="otp-phone-row">
                <span className="otp-phone">+91 {phoneNumber}</span>
                <button className="otp-edit" onClick={onEditPhone}>
                  Edit
                </button>
              </div>
              <form onSubmit={handleOtpSubmit}>
                <div className="otp-input-wrap">
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={4}
                    isInputNum
                    shouldAutoFocus
                    inputStyle="otp-input"
                    containerStyle="otp-container"
                    renderInput={(props) => <input {...props} />}
                  />
                </div>

                <div className="otp-resend-row">
                  <span
                    className={`otp-resend ${
                      resendTimer === 0 ? "active" : "disabled"
                    }`}
                    onClick={onResend}
                  >
                    Resend OTP{" "}
                    {resendTimer > 0
                      ? `in 0:${resendTimer.toString().padStart(2, "0")}`
                      : ""}
                  </span>
                </div>

                <button
                  className="submit-button otp-verify"
                  disabled={!isVerifyEnabled || loading}
                  style={{ lineHeight: "15px" }}
                >
                  {loading ? "Verifying..." : "Verify"}
                </button>
              </form>
            </div>
          )}
        </div>

        <div className="modal-branding-section">
          <div className="logo-section">
            <img
              src="/images/Logo.png"
              alt="Pankaj Jewellers Logo"
              className="trisa-logo"
            />
          </div>
          <div className="welcome-text">
            <h1 className="text-white">Welcome to Trisa!</h1>
            <p className="text-white">The Jewellery Brand</p>
          </div>
          <div className="feature-showcase">
            <div
              className={`feature-card-mobile ${
                isAnimating ? `sliding-${slideDirection}` : ""
              }`}
              onMouseEnter={handleCardHover}
              onMouseLeave={handleCardLeave}
            >
              <div className="feature-icon">
                <img src={features[currentSlide].icon} alt="Feature Icon" />
              </div>
              <div className="feature-content">
                <h3>{features[currentSlide].title}</h3>
                <p>{features[currentSlide].description}</p>
              </div>
            </div>
            <div className="pagination-dots">
              {features.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${index === currentSlide ? "active" : ""}`}
                  onClick={() => handleDotClick(index)}
                  aria-label={`Go to slide ${index + 1}`}
                  disabled={isAnimating}
                />
              ))}
            </div>
          </div>
          <div className="feature-cards">
            {features.map((feature, index) => (
              <div key={index} className="feature-card-2">
                <div className="feature-icon">
                  <img src={feature.icon} alt="Feature Icon" />
                </div>
                <div className="feature-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Authentication;
